// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c4d5b3f4","38":"29f564b4","317":"f382a031","420":"72d4fbd2","453":"9a750e67","757":"9989651c","817":"675b6582","943":"88f4e975","951":"36110fe3"}[chunkId] + ".chunk.js";
};